import { render, staticRenderFns } from "./TransportationPlanItem.vue?vue&type=template&id=bc09089e"
import script from "./TransportationPlanItem.vue?vue&type=script&lang=ts"
export * from "./TransportationPlanItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports